"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUploadPiclibInput = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var models_1 = require("../../../models");
var PropertyInputWrapper_1 = require("../PropertyInputWrapper");
var FileUpload_1 = require("./FileUpload");
var FileUploadPiclibInput = function (_a) {
    var propertyId = _a.propertyId, errorMessages = _a.errorMessages, _b = _a.disabled, disabled = _b === void 0 ? false : _b, className = _a.className, _c = _a.displayError, displayError = _c === void 0 ? false : _c, design = _a.design, status = _a.status, thumbnail = _a.thumbnail, onFileChange = _a.onFileChange, onFileSelect = _a.onFileSelect, onDelete = _a.onDelete, onReload = _a.onReload, uploadingFileSize = _a.uploadingFileSize, accept = _a.accept;
    var inputFont = design.colors.inputFont;
    return ((0, jsx_runtime_1.jsx)(PropertyInputWrapper_1.PropertyInputWrapper, __assign({ propertyId: propertyId, propertyType: models_1.PROPERTY_TYPE.fileUpload, inputFormatType: models_1.FILE_UPLOAD_PROPERTY_INPUT_TYPE.piclib, errorMessages: errorMessages, className: className, displayError: displayError }, { children: (0, jsx_runtime_1.jsx)(FileUpload_1.FileUpload, { propertyId: propertyId, disabled: disabled, displayError: displayError, color: inputFont, status: status, thumbnail: thumbnail, onFileChange: onFileChange, onFileSelect: onFileSelect, onDelete: onDelete, onReload: onReload, uploadingFileSize: uploadingFileSize, accept: accept }) })));
};
exports.FileUploadPiclibInput = FileUploadPiclibInput;
